import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { NewSupplierRegisterDetailReport } from './Pages/listing';

export const NewSupplierRegisterDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={NewSupplierRegisterDetailReport} />
    </Fragment>
)